import { Button, Grid, Paper, styled, Typography } from "@mui/material";
import { Form } from "formik";

export const StyledQr = {
  Title: styled("div")({
    color: "#484848",
    marginBottom: "8px",
    fontFamily: "Roboto, sans-serif",
    fontSize: "large",
    fontWeight: 500,
  }),

  StyledPaper: styled(Paper)({
    display: "flex",
    flexDirection: "column",
    padding: 20,
    marginBottom: 20,
  }),

  FormContainer: styled(Form)({
    display: "flex",
    width: "100%",
  }),

  AutocompleteContainer: styled("div")({
    width: "35%",
  }),

  QRContainer: styled("div")({
    textAlign: "center",
    marginTop: "50px",
  }),

  ButtonContainer: styled(Grid)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }),

  ErrorText: styled(Typography)({
    color: "red",
    marginTop: "8px",
  }),

  StyledButton: styled(Button)({
    marginLeft: 20,
  }),
};
